import { Play } from "lucide-react";

export function getEmbedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}

export function VideoEmbed({ url, title }) {
  const embed = getEmbedUrl(url);
  if (!embed) {
    return (
      <div
        className="aspect-video bg-slate-900 flex flex-col items-center justify-center text-white px-6 text-center"
        data-testid="video-coming-soon"
      >
        <Play className="h-10 w-10 text-pool mb-4" />
        <p className="text-xs tracking-[0.25em] uppercase text-white/60">Video coming soon</p>
        {title && <p className="mt-3 font-display text-xl sm:text-2xl font-bold">{title}</p>}
      </div>
    );
  }
  return (
    <div className="aspect-video bg-black">
      <iframe
        src={embed}
        title={title || "Video"}
        className="h-full w-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        data-testid="video-embed-frame"
      />
    </div>
  );
}
